// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWrenchIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="m21.132 16.873-7-6.997s-.08-.06-.12-.1V5a1 1 0 0 0-.631-.93l-5-1.999c-.44-.17-.941-.02-1.211.38a1 1 0 0 0 .13 1.26l2.6 2.598-.72 2.869-2.87.72-2.6-2.6a1 1 0 0 0-1.26-.13c-.4.26-.55.77-.38 1.21l2 4.998a1 1 0 0 0 .93.63h4.78s.06.08.1.12l7.002 6.996c.59.59 1.35.88 2.12.88s1.54-.29 2.12-.88a2.997 2.997 0 0 0 0-4.238zm-2.12 3.119c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1" />
  </g>
);
export default SvgWrenchIcon;
SvgWrenchIcon.displayName = 'SvgWrenchIcon';
